import { DEPART_DIRECTION } from './constants';

function serializeFilterParams(params = {}) {
    const {
        direction,
        originPlaceId,
        destinationPlaceId,
    } = params;

    if (!originPlaceId || !destinationPlaceId) {
        return undefined;
    }

    if (direction === DEPART_DIRECTION) {
        return `${originPlaceId}-${destinationPlaceId}`;
    }

    return `${destinationPlaceId}-${originPlaceId}`;
}

function buildPSearchParams(direction, params = {}) {
    if (!params.originPlace || !params.destinationPlace) {
        return undefined;
    }

    const parsedSeats = parseInt(params.passengers, 10);
    const seats = parsedSeats > 0 ? parsedSeats : undefined;

    if (direction === DEPART_DIRECTION) {
        return {
            currency: params.currency,
            departDatetime: params.departDate,
            destinationAddressComps: params.destinationPlace.address_components,
            destinationGeometry: params.destinationPlace.geometry,
            destinationPlaceId: params.destinationPlace.place_id,
            destinationText: params.destinationPlace.formatted_address,
            direction,
            locale: params.locale,
            originAddressComps: params.originPlace.address_components,
            originGeometry: params.originPlace.geometry,
            originPlaceId: params.originPlace.place_id,
            originText: params.originPlace.formatted_address,
            seats,
            seoReferrer: params.seoReferrer,
        };
    }

    return {
        currency: params.currency,
        departDatetime: params.returnDate,
        destinationAddressComps: params.originPlace.address_components,
        destinationGeometry: params.originPlace.geometry,
        destinationPlaceId: params.originPlace.place_id,
        destinationText: params.originPlace.formatted_address,
        direction,
        locale: params.locale,
        originAddressComps: params.destinationPlace.address_components,
        originGeometry: params.destinationPlace.geometry,
        originPlaceId: params.destinationPlace.place_id,
        originText: params.destinationPlace.formatted_address,
        seats,
        seoReferrer: params.seoReferrer,
    };
}

export {
    buildPSearchParams,
    serializeFilterParams,
};
